import {GruppeId, GruppeMedlemListeModell, GruppeModell, MedlemId, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component, computed, Injectable, Input, signal, ViewChild} from "@angular/core";
import {erZonedDateTimeTidligereEnn, lesZonedDateTimeSerialisert} from "felles-ng2/støttefunksjoner/temporal";
import {GruppemedlemDatatjeneste, MedlemmerGruppert} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {takeUntilDestroyed, toObservable} from "@angular/core/rxjs-interop";
import {MedlemKortKomponent} from "web-ng2/moduler/medlem/komponenter/medlem-kort/medlem-kort";
import {KortSamlingKomponent} from "web-ng2/delt/komponenter/kort/kort-samling/kort-samling";
import {KortSamlingOverskriftKomponent} from "web-ng2/delt/komponenter/kort/kort-samling-overskrift/kort-samling-overskrift";
import {TranslateModule} from "@ngx-translate/core";
import {MedlemInvitasjonOpprettKomponent} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-opprett/medlem-invitasjon-opprett";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {Observable, switchMap} from "rxjs";
import {MedlemInvitasjonKortKomponent} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-kort/medlem-invitasjon-kort";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {Temporal} from "temporal-polyfill";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {filterNil} from "@ngneat/elf";
import {distinctUntilChangedDeep} from "felles-ng2/støttefunksjoner/observable";
import ZonedDateTime = Temporal.ZonedDateTime;

const debug = initDebugger('MedlemmerVisKomponent');

@Component({
    selector: 'medlemmer-vis',
    templateUrl: 'medlemmer-vis.html',
    styleUrl: 'medlemmer-vis.scss',
    imports: [
        TranslateModule,
        KortSamlingKomponent,
        KortSamlingOverskriftKomponent,
        MedlemKortKomponent,
        MedlemInvitasjonOpprettKomponent,
        MedlemInvitasjonKortKomponent,
        TipsKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemmerVisKomponent {
    static ajsSelector = 'medlemmerVis';

    /** kort-samling-kontrolleren - merk at denne ikke er satt initielt, kan altså være undefined */
    @ViewChild(KortSamlingKomponent) kortsamling!: KortSamlingKomponent;

    gruppeSomSignal = signal<GruppeModell | null>(null);
    valgtMedlemSomSignal = signal<MedlemId | null>(null);

    medlemmer = new MedlemmerGruppert();
    kandidaterTilAnonymisering = computed(() => this.medlemmer.utenTilgangMedBrukertilknytning().filter(medlem => erZonedDateTimeTidligereEnn(lesZonedDateTimeSerialisert(medlem.medlemstatusSistEndret), this.anonymiseringsKandidatTerskel)));

    valgtMedlemErUtenTilgang = computed(() => this.medlemmer.utenTilgangMedBrukertilknytning().some(medlem => medlem.id === this.valgtMedlemSomSignal()))
    valgtMedlemErAnonymisert = computed(() => this.medlemmer.anonymiserte().some(medlem => medlem.id === this.valgtMedlemSomSignal()))

    viserMedlemmerUtenTilgang = signal(false);
    viserAnonymiserteMedlemmer = signal(false);
    /** hvorvidt bruker har nødv rolle for å kunne redigere medlem */
    redigeringMulig = computed(() => erIkkeNil(this.gruppeSomSignal()) && this.kontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.gruppeSomSignal()!.id));

    private readonly anonymiseringsKandidatTerskel: ZonedDateTime;

    constructor(private avhengigheter: MedlemmerVisKomponentAvhengigheter, private kontekst: BrukerkontekstTilbyder, private klokke: Klokke) {
        this.anonymiseringsKandidatTerskel = this.klokke.nåSomZonedDateTime().subtract({years: 1});
        //hent medlemmer hver gang gruppe endres
        toObservable(this.gruppeSomSignal).pipe(filterNil(), switchMap(gruppe => this.avhengigheter.medlemmer(gruppe.id)), takeUntilDestroyed())
          .subscribe(medlemmer => this.medlemmer.oppdater(medlemmer));
    }

    //ikke def som input() da dette ikke fungerer når komponent kalles fra ajs
    @Input({required: true}) set gruppe(gruppe: GruppeModell) {
        this.gruppeSomSignal.set(gruppe);
    }

    //ikke def som input() da dette ikke fungerer når komponent kalles fra ajs
    @Input() set valgtMedlemId(id: MedlemId | null) {
        this.valgtMedlemSomSignal.set(id);
    }

    // private hjelpemetoder
}

@Injectable()
export class MedlemmerVisKomponentAvhengigheter {

    constructor(private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste) {
    }

    medlemmer(id: GruppeId): Observable<GruppeMedlemListeModell[]> {
        return this.gruppemedlemDatatjeneste.finnTilknyttet(id).pipe(distinctUntilChangedDeep());
    }
}
